export const dynamicRenderElementId = 'dynamic-render-container'
